<template>
  <div class="d-inline-block">
    <a
      v-if="!gated"
      download
      :class="btnClass"
      :href="fileGetter && fileGetter.sourceDownloadURL"
    >
      <i class="fa fa-download" :class="{ 'mr-2': label, worklistIcon: !label }"></i>{{ label }}
    </a>
    <button
      v-else
      type="button"
      :class="btnClass"
      :disabled="loading || !resolvedFileId"
      @click.prevent="gatedDownload"
      :title="errorMessage || 'Download'"
    >
      <i
        v-if="loading"
        class="fa fa-spinner fa-spin"
        :class="{ 'mr-2': label, worklistIcon: !label }"
      ></i>
      <i v-else class="fa fa-download" :class="{ 'mr-2': label, worklistIcon: !label }"></i>{{ label }}
    </button>
    <div v-if="gated && errorMessage" class="text-danger small mt-1">{{ errorMessage }}</div>
  </div>
</template>

<script>
import { Firebase } from "@/firebase";

export default {
  props: {
    file: { default: null },
    fileID: { default: null },
    gated: { type: Boolean, default: false },
    label: { type: String, default: "" },
    btnClass: { type: String, default: "btn btn-sm" },
  },
  name: "downloader",
  data() {
    return {
      loading: false,
      errorMessage: "",
    };
  },
  computed: {
    fileGetter() {
      if (this.fileID) {
        return this.$store.getters["files/fileById"](this.fileID);
      }
      return this.file;
    },
    resolvedFileId() {
      if (this.fileID) return this.fileID;
      if (this.file && this.file.id) return this.file.id;
      return null;
    },
  },
  methods: {
    async gatedDownload() {
      if (this.loading || !this.resolvedFileId) return;
      this.loading = true;
      this.errorMessage = "";
      try {
        const callable = Firebase.app()
          .functions("europe-west2")
          .httpsCallable("requestClipDownload");
        const result = await callable({ fileId: this.resolvedFileId });
        const url = result && result.data && result.data.url;
        if (!url) {
          throw new Error("No download URL returned");
        }
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "");
        link.rel = "noopener";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (e) {
        console.error(e);
        const code = e && (e.code || (e.details && e.details.code));
        const message =
          (e && e.message) ||
          "Download failed. Please try again or contact an administrator.";
        // Firebase wraps HttpsError messages as "RESOURCE_EXHAUSTED: ..."
        const cleaned = String(message).replace(/^[^:]+:\s*/, "");
        this.errorMessage = cleaned || message;
        if (this.$notify) {
          this.$notify({
            type: "danger",
            message: this.errorMessage,
            timeout: 6000,
          });
        }
        // silence unused
        void code;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
